import { NgModule } from "@angular/core";
import { AppsSvgComponent } from "./apps/apps.component";
import { ArrowSvgComponent } from "./arrow/arrow.component";
import { BlinkerSvgComponent } from "./blinker/blinker.component";
import { CloseSvgComponent } from "./close/close.component";
import { DeleteSvgComponent } from "./delete/delete.component";
import { DownArrowSvgComponent } from "./down-arrow/down-arrow.component";
import { DownloadSvgComponent } from "./download/download.component";
import { ExternalLinkSvgComponent } from "./external-link/external-link.component";
import { FilterSvgComponent } from "./filter/filter.component";
import { GridSvgComponent } from "./grid/grid.component";
import { MenuSvgComponent } from "./menu/menu.component";
import { PlaySvgComponent } from "./play/play.component";
import { SearchSvgComponent } from "./search/search.component";
import { SortSvgComponent } from "./sort/sort.component";
import { SpxLogoSvgComponent } from "./spx-logo/spx-logo.component";
import { XSocialSvgComponent } from "./x-social/x-social.component";
import { ThinArrowSvgComponent } from "./thin-arrow/thin-arrow.component";

@NgModule({
  declarations: [
    AppsSvgComponent,
    ArrowSvgComponent,
    BlinkerSvgComponent,
    CloseSvgComponent,
    DeleteSvgComponent,
    DownArrowSvgComponent,
    DownloadSvgComponent,
    ExternalLinkSvgComponent,
    FilterSvgComponent,
    GridSvgComponent,
    MenuSvgComponent,
    PlaySvgComponent,
    SearchSvgComponent,
    SortSvgComponent,
    SpxLogoSvgComponent,
    ThinArrowSvgComponent,
    XSocialSvgComponent,
  ],
  exports: [
    AppsSvgComponent,
    ArrowSvgComponent,
    BlinkerSvgComponent,
    CloseSvgComponent,
    DeleteSvgComponent,
    DownArrowSvgComponent,
    DownloadSvgComponent,
    ExternalLinkSvgComponent,
    FilterSvgComponent,
    GridSvgComponent,
    MenuSvgComponent,
    PlaySvgComponent,
    SearchSvgComponent,
    SortSvgComponent,
    SpxLogoSvgComponent,
    ThinArrowSvgComponent,
    XSocialSvgComponent
  ],
})
export class IconsModule { }
